import { Component, Input } from '@angular/core';
import {
  GetPendingEmailDomainTargetCNameRecordsInterface,
  VerifyPendingEmailDomainResponseInterface,
} from '@vendasta/email';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

export interface DomainStatus {
  targetSpf?: string;
  currentSpf?: string;
  targets?: GetPendingEmailDomainTargetCNameRecordsInterface;
}

@Component({
  selector: 'email-domain-status-icon',
  templateUrl: './domain-status-icon.component.html',
  styleUrls: ['./domain-status-icon.component.scss'],
  imports: [CommonModule, MatIconModule],
})
export class DomainStatusIconComponent {
  @Input() result: VerifyPendingEmailDomainResponseInterface;
}
